export interface BreadcrumbItem {
  text: string
  link: string | null
  active: boolean
}

export enum Layout{
  GRID, COLUMN
}
